/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventAssignController', DinghyEventAssignController);

    DinghyEventAssignController.$inject = ['$uibModalInstance', 'entity', 'PrincipalProfile', '$http'];

    function DinghyEventAssignController($uibModalInstance, entity, PrincipalProfile, $http) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.initialGodparent = vm.dinghyEvent.godparent;
        vm.currentProfile = null;
        vm.clear = clear;
        vm.confirmAssign = confirmAssign;

        PrincipalProfile.identity(false).then(function(profile) {
            vm.currentProfile = profile;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmAssign () {
            vm.dinghyEvent.godparent = vm.currentProfile;
            vm.eventAssigned = {
                id: vm.dinghyEvent.id,
                contactEmail: vm.dinghyEvent.contactEmail,
                managerComment: vm.managerComment,
                godparent: vm.currentProfile
            }
            $http.post('api/board/dinghy-events/assign/', vm.eventAssigned).then(function() {
                $uibModalInstance.close(true);
            });
        }
    }
})();
